import { DependencyLifeTime, Injectable } from "@miracledevs/paradigm-web-di";
import { createElement, ReactElement } from "react";
import { ContextCollection } from "../../contexts/DependencyContext";
import { IWidget } from "../http/widget/models/IWidget";
import { WidgetTypes } from "../http/widget/models/WidgetTypes";
import { ICurrentIssuesConfiguration } from "../http/widget/models/ICurrentIssuesConfiguration";
import { IStatusHistoryConfiguration } from "../http/widget/models/IStatusHistoryConfiguration";
import { ISensorChartConfiguration } from "../http/widget/models/ISensorChartConfiguration";
import { IWeatherConfiguration } from "../http/widget/models/IWeatherConfiguration";
import { IMachineLearningPredictionConfiguration } from "../http/widget/models/IMachineLearningPredictionConfiguration";
import Summary from "../../components/Shared/ContentBlocks/Summary";
import CurrentIssues from "../../components/Shared/ContentBlocks/CurrentIssues";
import StatusHistory from "../../components/Shared/ContentBlocks/StatusHistory";
import SensorChart from "../../components/Shared/ContentBlocks/SensorChart";
import Production from "../../components/Shared/ContentBlocks/Production";
import Weather from "../../components/Shared/ContentBlocks/Weather";
import SensorIcon from "../../components/Shared/ContentBlocks/SensorIcon";
import MachineLearningPrediction from "../../components/Shared/ContentBlocks/MachineLearningPrediction";
import PumpPerformanceCurves from "../../components/Shared/ContentBlocks/PumpPerformanceCurves";
import NoWidget from "../../components/Shared/ContentBlocks/NoWidget";
import { BaseWidgetService } from "./BaseWidgetService";

@Injectable({ collection: ContextCollection, lifeTime: DependencyLifeTime.Singleton })
export class WidgetService extends BaseWidgetService {

    getWidgetBody(widget: IWidget): ReactElement
    {
        switch (widget.widgetTypeId)
        {
            case WidgetTypes.Summary:
                return createElement(Summary, (this.getWidgetConfig(widget)));
            case WidgetTypes.CurrentIssues:
                return createElement(CurrentIssues, (this.getWidgetConfig(widget)));
            case WidgetTypes.StatusHistory:
                return createElement(StatusHistory, (this.getWidgetConfig(widget)));
            case WidgetTypes.SensorChart:
                return createElement(SensorChart, (this.getWidgetConfig(widget)));
            case WidgetTypes.Production:
                return createElement(Production);
            case WidgetTypes.Weather:
                return createElement(Weather, (this.getWidgetConfig(widget)));
            case WidgetTypes.SensorIcon:
                return createElement(SensorIcon);
            case WidgetTypes.MachineLearningPrediction:
                return MachineLearningPrediction(this.getWidgetConfig(widget));
            case WidgetTypes.PumpPerformanceCurves:
                return PumpPerformanceCurves(this.getWidgetConfig(widget));
            default:
                return createElement(NoWidget, (widget.widgetType));
        }
    }

    getWidgetConfig(widget: IWidget): any {
        switch (widget.widgetTypeId)
        {
            case WidgetTypes.Summary:
                return {description: widget.description};

            case WidgetTypes.CurrentIssues:
                const currentIssuesConfiguration = JSON.parse(widget.uiConfiguration) as ICurrentIssuesConfiguration;
                return {componentId: currentIssuesConfiguration.componentId, widgetId: widget.id};

            case WidgetTypes.StatusHistory:
                const onDashboard = window.location.pathname.includes("dashboard");
                const statusHistoryConfiguration = JSON.parse(widget.uiConfiguration) as IStatusHistoryConfiguration;
                return {
                    componentId: statusHistoryConfiguration.componentId,
                    indicatorId: statusHistoryConfiguration.indicatorId,
                    hasFullWidth: onDashboard
                };
            case WidgetTypes.SensorChart:
                const sensorChartConfiguration = JSON.parse(widget.uiConfiguration) as ISensorChartConfiguration;
                return {dataSourceId: sensorChartConfiguration.dataSourceId, uiConfiguration: widget.uiConfiguration};

            case WidgetTypes.Weather:
                const weatherConfiguration = JSON.parse(widget.uiConfiguration) as IWeatherConfiguration;
                return {componentId: weatherConfiguration.componentId};

            case WidgetTypes.MachineLearningPrediction:
                const machineLearningPredictionConfiguration = JSON.parse(widget.uiConfiguration) as IMachineLearningPredictionConfiguration;
                return {
                    dataSourceId: machineLearningPredictionConfiguration.dataSourceId,
                    indicatorId: machineLearningPredictionConfiguration.indicatorId
                };

            case WidgetTypes.PumpPerformanceCurves:
                return {
                    uiConfiguration : widget.uiConfiguration
                };

            case WidgetTypes.Production:
            case WidgetTypes.SensorIcon:
            default:
                return;
        }
    }
}